// extracted by mini-css-extract-plugin
export default {"wrapper":"ANN1ve","section":"pqDOPH","section--xl":"CGeyg8","section--l":"HLw_SC","section--m":"vJoqWh","section--s":"NDtT6w"};